export default {
  label: {
    computer: 'Computador',
    mobile: 'Celular/Tablet',
    notClassified: 'Não Classificado',
  },
};
